import React from 'react';
import { CloseIcon } from '@domain-group/fe-co-icon';
import { Button } from '../button';
import * as styles from './header.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Header = _ref => {
  var _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? '' : _ref$heading,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? [] : _ref$actions,
    closeButton = _ref.closeButton,
    handleClose = _ref.handleClose,
    _ref$showHeader = _ref.showHeader,
    showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
    appearance = _ref.appearance;
  var show = heading || actions ? showHeader : false;
  var hasActions = actions.length > 0;
  return ___EmotionJSX("div", {
    css: styles.container(show)
  }, ___EmotionJSX("div", {
    css: styles.heading({
      appearance,
      hasActions
    })
  }, ___EmotionJSX("div", {
    css: styles.headingBody
  }, heading)), hasActions && ___EmotionJSX("div", {
    css: styles.actions(showHeader)
  }, ___EmotionJSX("div", {
    css: styles.actions(showHeader)
  }, actions)), ___EmotionJSX("div", {
    css: styles.dismiss({
      hasActions,
      appearance
    })
  }, closeButton || ___EmotionJSX(Button, {
    appearance: "ghostNeutral",
    icon: ___EmotionJSX(CloseIcon, null),
    onClick: handleClose
  })));
};
export default Header;